import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35f987db"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "spot" }
const _hoisted_2 = { class: "spot-inner" }

import { computed, PropType, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'

import gsap from 'gsap'

import { useAppState } from '@/services/composition'
import { useGameState } from '@/services/composition'
import { Hotspot, useMapHotspots } from '@/services/stores/hotspots'

import CompanionHotspotDetails from './CompanionHotspotDetails.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  hotspot: {
    type: Object as PropType<Hotspot>,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props

const state = useGameState()

const { t } = useI18n()
const { send } = useAppState()
const { findHotspot: findMapHotspot } = useMapHotspots()



const isSelected = computed(() => {
  return state.value.context.hotspotSelected === props.hotspot.id
})

const isExit = computed(() => {
  return state.value.matches('tuto.xr.exit_room') || state.value.matches('game.bedroom.exit_room') || state.value.matches('game.corridor.exit_room') || state.value.matches('game.studyroom.exit_room') || state.value.matches('game.living.exit_room')
})

const isAdvised = computed(() => {
  return state.value.context.advisedHotspots.includes(props.hotspot.id)
})

const isDone = computed(() => {
  return state.value.context.hotspots.includes(props.hotspot.id) || isExit.value
})

const hasDoneRight = computed(() => {
  return isDone.value && props.hotspot.points > 0
})

const hasDoneBad = computed(() => {
  return isDone.value && props.hotspot.points < 0
})

const hotspotClass = computed(() => {
  return {
    disabled: props.disabled,
    selected: isSelected.value,
    advised: isAdvised.value,
    done: isDone.value,
    success: hasDoneRight.value,
    fail: hasDoneBad.value
  }
})

const circleClass = computed(() => {
  return {
    'circle--selected': isSelected.value,
    'circle--advised': isAdvised.value,
    'circle--done': isDone.value,
    'circle--success': hasDoneRight.value,
    'circle--fail': hasDoneBad.value,
  }
})

const circleKey = computed(() => {
  if (isSelected.value) {
    return 'selected'
  }
  if (isAdvised.value) {
    return 'advised'
  }
  if (hasDoneRight.value) {
    return 'success'
  }
  if (hasDoneBad.value) {
    return 'fail'
  }

  return 'disabled'
})

const position = computed(() => {
  return findMapHotspot(props.hotspot.id).position
})

const transform = computed(() => {
  return { left: `${position.value[0] * 100}%`, top: `${position.value[1] * 100}%` }
})

const icon = computed(() => {
  if (hasDoneRight.value) {
    return 'checkmark'
  }
  if (hasDoneBad.value) {
    return 'crossmark'
  }
  return props.hotspot.icon
})

const handleClick = () => {
  send({ type: 'GAME_HOTSPOT_SELECT', payload: !isSelected.value ? props.hotspot.id : -1 })
}

const handleAdvise = () => {
  send({ type: 'GAME_HOTSPOT_ADVISE', payload: props.hotspot.id })
}

const onEnterSpotBackground = (el: Element, onComplete: gsap.Callback) => {
  const tl = gsap.timeline({ onComplete })
  tl.fromTo(el, { scale: 0 }, { scale: 1, duration: 1, ease: 'quint.out' })
}

const onLeaveSpotBackground = (el: Element, onComplete: gsap.Callback) => {
  const tl = gsap.timeline({ onComplete })
  tl.to(el, { scale: 0, duration: 1, ease: 'quint.in' })
}

const onEnterSpotIcon = (el: Element, onComplete: gsap.Callback) => {
  const tl = gsap.timeline({ onComplete })
  tl.fromTo(el, { yPercent: 100, opacity: 0 }, { yPercent: 0, opacity: 1, duration: 1, ease: 'quint.out' })
}

const onLeaveSpotIcon = (el: Element, onComplete: gsap.Callback) => {
  const tl = gsap.timeline({ onComplete })
  tl.to(el, { yPercent: -100, opacity: 0, duration: 1, ease: 'quint.in' })
}

return (_ctx: any,_cache: any) => {
  const _component_ui_icon = _resolveComponent("ui-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["hotspot", _unref(hotspotClass)]),
      style: _normalizeStyle(_unref(transform)),
      onClick: handleClick
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_Transition, {
            css: false,
            mode: "",
            appear: "",
            onEnter: onEnterSpotBackground,
            onLeave: onLeaveSpotBackground
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock("span", {
                class: _normalizeClass(['circle', _unref(circleClass)]),
                key: _unref(circleKey)
              }, null, 2))
            ]),
            _: 1
          }),
          _createVNode(_Transition, {
            css: false,
            mode: "out-in",
            appear: "",
            onEnter: onEnterSpotIcon,
            onLeave: onLeaveSpotIcon
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock("div", {
                class: "icon",
                key: _unref(icon)
              }, [
                _createVNode(_component_ui_icon, { name: _unref(icon) }, null, 8, ["name"])
              ]))
            ]),
            _: 1
          })
        ])
      ])
    ], 6),
    _withDirectives(_createVNode(CompanionHotspotDetails, { hotspot: __props.hotspot }, null, 8, ["hotspot"]), [
      [_vShow, _unref(isSelected) && !_unref(isAdvised)]
    ])
  ]))
}
}

})